export const Data = [
  {
    name: 'Jan',
    'Active User': 4000,
  },
  {
    name: 'Feb',
    'Active User': 3000,
  },
  {
    name: 'March',
    'Active User': 1000,
  },
  {
    name: 'April',
    'Active User': 3000,
  },
  {
    name: 'May',
    'Active User': 500,
  },
  {
    name: 'Jun',
    'Active User': 4000,
  },
  {
    name: 'Jul',
    'Active User': 2000,
  },
  {
    name: 'Aug',
    'Active User': 3000,
  },
  {
    name: 'Sept',
    'Active User': 1000,
  },
  {
    name: 'Oct',
    'Active User': 5000,
  },
  {
    name: 'Nov',
    'Active User': 3000,
  },
  {
    name: 'Dec',
    'Active User': 5000,
  },
];

export const ProductData = [
  {
    name: 'Jan',
    Sales: 4000,
  },
  {
    name: 'Feb',
    Sales: 3000,
  },
  {
    name: 'March',
    Sales: 1000,
  },
  {
    name: 'April',
    Sales: 3000,
  },
  {
    name: 'May',
    Sales: 500,
  },
  {
    name: 'Jun',
    Sales: 4000,
  },
];

export const rows = [
  {
    id: 1,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },

  {
    id: 2,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 3,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 4,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 5,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 6,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 7,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },

  {
    id: 8,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 9,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 10,
    username: 'John Snow',
    avatar:
      'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
  {
    id: 11,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/1386604/pexels-photo-1386604.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    stock: 'john@gmail.com',
    status: 'active',
    transaction: '$122',
  },
];

export const prorows = [
  {
    id: 1,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 2,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 3,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 4,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 5,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 6,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 7,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 8,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 9,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
  {
    id: 10,
    name: 'Apple Airpods',
    img: 'https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    stock: 123,
    status: 'active',
    price: '$120.00',
  },
];
